[
  {
    "possibleTypes": [
      {
        "name": "SearchConfluencePageBlogAttachment"
      },
      {
        "name": "SearchConfluenceSpace"
      }
    ],
    "kind": "INTERFACE",
    "name": "SearchResult"
  },
  {
    "possibleTypes": [
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceBlogPost"
      }
    ],
    "kind": "UNION",
    "name": "SearchConfluenceEntity"
  },
  {
    "possibleTypes": [
      {
        "name": "AppUser"
      },
      {
        "name": "AtlassianAccountUser"
      },
      {
        "name": "CustomerUser"
      }
    ],
    "kind": "INTERFACE",
    "name": "User"
  },
  {
    "possibleTypes": [
      {
        "name": "InvokeAuxEffectsResponse"
      },
      {
        "name": "InvokeExtensionResponse"
      }
    ],
    "kind": "INTERFACE",
    "name": "Payload"
  }
]

